import { Pipe, PipeTransform } from '@angular/core';
import { usesCompanyAsDisplayName } from '../utils/util-function';

@Pipe({
  name: 'companyDisplayName'
})
export class CompanyDisplayNamePipe implements PipeTransform {

  transform(value: any) {
    if (!value) return
    let response = ''
    const companyName = (value.CompanyName || '').trim();
    if (usesCompanyAsDisplayName(value.DisplayCompanyName, companyName)) {
      response = companyName + ' ' + `(${value.FirstName + (value.LastName ? ' ' + value.LastName:'')})`;
    }
    else if (companyName) {
      response = value.FirstName + ' ' + value.LastName + ' ' + `(${companyName})`;
    }
    else {
      response = value.FirstName + ' ' + value.LastName
    }
    return response;
  }

}
